import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { CardInfoComponent } from '../../layout/components/card-info/card-info.component';
import { CardToggleComponent } from '../../card-toggle/card-toggle.component';
import { GoogleMapComponent } from '../../layout/components/google-map/google-map.component';
import { RefundComponent } from '../../refund/refund/refund.component'
import { RefundSuccessComponent } from '../../refund/refund-success/refund-success.component'
import { RefundFailComponent } from '../../refund/refund-fail/refund-fail.component'
import { SharedDataService } from '../../services/shared-data.service'
import { SalesComponent } from '../sales/sales.component'
import { DatePipe } from '@angular/common';
import { Apollo, gql, ApolloModule } from 'apollo-angular';
import { HttpClientModule, HttpHeaders } from '@angular/common/http'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PaymentIntentsService } from '../../services/graphQl/payment-intents/payment-intents.service';
import { NormalizeDataService } from '../../services/normalize-data.service';
import { TooltipComponent } from '../../layout/components/tooltip/tooltip.component';
import { voucherSaleContent } from './voucher-html/sale-detail-voucher-html-content';
import { voucherRefundContent } from './voucher-html/refund-detail-voucher-html-content';
import html2pdf from 'html2pdf.js';
import { GraphPaymentIntent, GraphPaymentIntentTransformed, InstallmentTypeEnum } from '../../models/paymentIntent/paymentIntent.interface';

@Component({
  selector: 'app-sale-detail',
  standalone: true,
  imports: [
    RouterLink,
    CardInfoComponent,
    GoogleMapComponent,
    RefundComponent,
    RefundSuccessComponent,
    RefundFailComponent,
    CardToggleComponent,
    ApolloModule,
    HttpClientModule,
    NgxSkeletonLoaderModule,
    DatePipe,
    TooltipComponent
  ],
  templateUrl: './sale-detail.component.html',
  styleUrl: './sale-detail.component.css'
})
export class SaleDetailComponent implements OnInit, OnDestroy {
  public transaction: GraphPaymentIntentTransformed;
  public fechaHoraFormateada: string;
  mostrarContenido: boolean = false;
  id: string;
  loader: boolean = true;
  channel: string;
  operation_type: string;
  public parsedMetadataTable: { key: string, value: any }[] = [];
  public parentTransaction: any;
  created_at_parent_id: string = '';
  authorization_code_parent_id: string = '';
  lastfourdigit_parent_id: string = '';
  amount_parent_id: string = '';

  isParentTransactionLoaded: boolean = false;

  tooltipTitle = 'En proceso de confirmación'
  merchantIdentificationNumber: string;
  merchantAddress: string;
  constructor(
    public sharedDataService: SharedDataService,
    private route: ActivatedRoute,
    private apollo: Apollo,
    private paymentIntentsService: PaymentIntentsService,
    public normalizeDataService: NormalizeDataService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');

      this.paymentIntentsService.queryPaymentIntentDetail(this.id).subscribe({
        next: (result: any) => {
          const resultDetail = result.data?.paymentIntentDetail as GraphPaymentIntent;

          // Copiar el objeto para hacerlo mutable
          this.transaction = {
            ...resultDetail,
            masked_card_number: this.maskCardNumber(resultDetail.bin, resultDetail.lastfourdigit),
            updated_at: new Date(resultDetail.updated_at + 'UTC').toString(),
            created_at: new Date(resultDetail.created_at + 'UTC').toString(),
            expired_at: new Date(resultDetail.expired_at + 'UTC').toString(),
          };

          console.log('this.transaction', this.transaction);
    
          console.log("Detalle:", this.transaction)
          console.log("CHANNEL:", this.channel)
          this.loader = false;
          this.channel = this.transaction.channel;
          this.operation_type = this.transaction.operation_type;

          //parse metadata
          let parsedMetadata = JSON.parse(this.transaction.metadata) || {};
          try {
            // Parse the JSON string into an object
            let parsedMetadata = JSON.parse(this.transaction.metadata);
      
            // Convert the object into an array of key-value pairs
            this.parsedMetadataTable = Object.keys(parsedMetadata)
              .filter(key => key !== 'connectivity')
              .map(key => ({
                key: key,
                value: parsedMetadata[key]
              }));
          } catch (error) {
            console.error('Invalid JSON string:', error);
          }
          if (this.transaction.operation_type?.toLowerCase() === 'refund' && this.transaction.paymentintent_parent_id) {
          this.paymentIntentsService.queryPaymentIntentDetail(this.transaction.paymentintent_parent_id)
            .subscribe((parentResult: any) => {
              this.parentTransaction = parentResult.data?.paymentIntentDetail;

              this.created_at_parent_id =  this.parentTransaction?.created_at || '';
              this.authorization_code_parent_id = this.parentTransaction?.authorization_code || '';
              this.lastfourdigit_parent_id = this.parentTransaction?.lastfourdigit || '';
              this.amount_parent_id = this.parentTransaction?.amount || ''
              console.log("Transacción original (parent):", this.parentTransaction);
              console.log("lastfourdigit(parent):", this.parentTransaction?.lastfourdigit);
              console.log("created_at_parent_id", this.parentTransaction?.created_at || '');
              console.log("amount_parent_id", this.parentTransaction?.amount || '');
              console.log("authorization_code_parent_id", this.parentTransaction?.authorization_code || '');
              console.log("lastfourdigit_parent_id", this.parentTransaction?.lastfourdigit || '');
              this.isParentTransactionLoaded = true;
            });
          }
        },
        error(err) {
            console.error('Error obteniendo detalle de transacción', err);
        }
      });
    });

    let cadena = localStorage.getItem(`channel_${this.id}`);
    if(cadena) {
      let partes = cadena.split("/");
  
      this.channel = partes[0];
      this.operation_type = partes[1];
    } else {
      //channel y operation_type por defecto
      this.channel = "IN_PERSON";
      this.operation_type = "purchase";
    }

    console.log("channel:", this.channel)
    console.log("operation_type:", this.operation_type)
  }

  // metodo para ofuscar el numero de tarjeta
  maskCardNumber(bin: string, lastFour: string): string {
    // si falta algún dato, retorna un valor por defecto
    if (!bin || bin.length < 6 || !lastFour || lastFour.length !== 4) {
      return "**** **** **** ****";
    }
    return `**** **** **** ${lastFour}`; // formato de 16 dígitos
  }

  ngOnDestroy(): void {
    localStorage.removeItem(`channel_${this.id}`);
  }

  handleClick(): void {
    this.sharedDataService.setRefundButton(true);
    localStorage.setItem('refund.bin', this.transaction.bin);
    localStorage.setItem('refund.lastfourdigit', this.transaction.lastfourdigit);
    localStorage.setItem('refund.network', this.transaction.network);
    localStorage.setItem('refund.payment_id', this.id);
    localStorage.setItem('refund.id_merchant', this.transaction.merchant_id);
    localStorage.setItem('refund.terminal_type', this.transaction.terminal_type);
  }

  toggleContenido() {
    this.mostrarContenido = !this.mostrarContenido;
  }

  translateOperationType(operationType: string): string {
    switch (operationType) {
      case 'purchase':
        return 'VENTA';
      case 'reversal':
        return 'REVERSA';
      case 'refund':
        return 'DEVOLUCION';
      default:
        return operationType.toUpperCase(); // Si no coincide con ninguno, devuelve el valor en mayúsculas
    }
  }

  getMetadataValue(key: string): string | null {
    if (!this.parsedMetadataTable) return null;
    const item = this.parsedMetadataTable.find(item => item.key === key);
    return item ? String(item.value) : null;
}

translateInstallmentType(type: InstallmentTypeEnum | null): string {
  if (!type) return '-';
  
  const translations: Record<InstallmentTypeEnum, string> = {
      [InstallmentTypeEnum.MERCHANT_INSTALLMENT]: 'Merchant',
      [InstallmentTypeEnum.ISSUER_INSTALLMENT]: 'Issuer',
      [InstallmentTypeEnum.NO_INSTALLMENT]:"-"
  };

  return translations[type] || type;
}

downloadReceiptAsPDF(): void {
  const finalHtmlContent = this.replaceHtmlContentPlaceholders(voucherSaleContent, voucherRefundContent);

  const container = document.createElement('div');
  const formatted_operation_type = this.translateOperationTypeToSpanish(this.transaction?.operation_type || '');
  const operation_number = this.transaction?.operation_number || '';
  const created_at = this.transaction?.created_at || '';
  const created_at_short = this.formatDateToShort(created_at);
  const filename = `comprobante_${formatted_operation_type}_${operation_number}_${created_at_short}.pdf`;
  container.innerHTML = `
    <div style="padding-bottom: 20px; page-break-inside: avoid;">
      ${finalHtmlContent}
    </div>
  `;

  document.body.appendChild(container);

  const opt = {
    margin: [10, 10, 20, 10],
    filename,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: {
      scale: 2,
      scrollY: 0,
      windowWidth: 800
    },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    pagebreak: { mode: ['css', 'legacy'] }
  };

  html2pdf().set(opt).from(container).save().then(() => {
    document.body.removeChild(container);
  });
}

private replaceHtmlContentPlaceholders(saleContent: string, refundContent: string): string {

const operation_number = this.transaction?.operation_number || '';
const formatted_amount = this.formatAmount(this.transaction?.amount || 0);
const authorization_code = this.transaction?.authorization_code || '';
const formatted_operation_type = this.translateOperationTypeToSpanish(this.transaction?.operation_type || '');
const formatted_network_type = this.normalizeNetworkAndType(this.transaction?.network || '', this.transaction?.type || '');
const installment_count = this.transaction?.installment_count?.toString() || '';
const created_at = this.transaction?.created_at_time_zone || '';
const merchant_name = localStorage.getItem('merchant_name') || '';
const branch_name = this.transaction?.merchant_name || '';
const lastfourdigit = this.transaction?.lastfourdigit || '';
const format_date = this.formatDateToLongSpanish(created_at);
const status = this.translateStatusToSpanish(this.transaction?.status || '');
const created_at_short = this.formatDateToShort(created_at);
const merchant_identification_number = localStorage.getItem('merchant_identification_number');
const merchant_address = localStorage.getItem('merchant_address');
const merchant_address_line = localStorage.getItem('merchant_address_line');
const created_at_short_parent_id = this.formatDateToShort(this.created_at_parent_id);
const formatted_amount_parent_id = this.formatAmount(parseInt(this.amount_parent_id));


if (formatted_operation_type == 'Venta') {
  let finalSaleHtmlContent = saleContent;
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[operation_number\]/g, operation_number);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[amount\]/g, formatted_amount);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[authorization_code\]/g, authorization_code);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[operation_type\]/g, formatted_operation_type);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[network_type\]/g, formatted_network_type);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[installment_count\]/g, installment_count);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[status\]/g, status);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[created_at\]/g, created_at_short);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[format_date\]/g, format_date);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[merchant_name\]/g, merchant_name);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[lastfourdigit\]/g, lastfourdigit);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[merchant_rut\]/g, merchant_identification_number);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[merchant_address\]/g, merchant_address);
  finalSaleHtmlContent = finalSaleHtmlContent.replace(/\[branch_name\]/g, branch_name);

  return finalSaleHtmlContent;
}

if (formatted_operation_type == 'Reembolso'){
  let finalRefundHtmlContent = refundContent;
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[operation_number\]/g, operation_number);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[format_date\]/g, format_date);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[merchant_name\]/g, merchant_name);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[operation_type\]/g, formatted_operation_type);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[merchant_rut\]/g, merchant_identification_number);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[merchant_address\]/g, merchant_address);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[amount\]/g, formatted_amount);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[status\]/g, status);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[refund_request_date\]/g, created_at_short);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[transaction_type\]/g, formatted_operation_type);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[lastfourdigit\]/g, this.lastfourdigit_parent_id);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[authorization_code\]/g, authorization_code);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[branch_name\]/g, branch_name);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[created_at\]/g, created_at_short_parent_id);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[sale_amount\]/g, formatted_amount_parent_id);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[sale_authorization_code\]/g, this.authorization_code_parent_id);
  finalRefundHtmlContent = finalRefundHtmlContent.replace(/\[refund_order_number\]/g, this.transaction.order_number);

  return finalRefundHtmlContent;
}

return null

}

private formatAmount(amount: number): string {
  const formatted = amount.toLocaleString('es-CL');
  return `$ ${formatted} CLP`;
}

private translateOperationTypeToSpanish(operationType: string): string {
  const translations: Record<string, string> = {
    'purchase': 'Venta',
    'reversal': 'Reversa',
    'refund': 'Reembolso'
  };
    return translations[operationType] || operationType;
}


private normalizeNetworkAndType(network: string, type: string): string {
  const normalizedNetwork = network?.toLowerCase() || '';
  const normalizedType = type?.toLowerCase() || '';

  return `${normalizedNetwork} ${normalizedType}`.trim();
}

private formatDateToLongSpanish(dateInput: any): string {
  let date: Date;

  if (typeof dateInput === 'string') {
    date = new Date(dateInput.replace(' ', 'T'));
  } else if (dateInput instanceof Date) {
    date = dateInput;
  } else {
    return '';
  }
  if (isNaN(date.getTime())) return '';

  const day = date.getDate();
  const year = date.getFullYear();

  const monthNames = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];
  const month = monthNames[date.getMonth()];

  return `${day} de ${month} de ${year}`;
}

private formatDateToShort(dateInput: any): string {
  let date: Date;

  if (typeof dateInput === 'string') {
    date = new Date(dateInput.replace(' ', 'T'));
  } else if (dateInput instanceof Date) {
    date = dateInput;
  } else {
    return '';
  }

  if (isNaN(date.getTime())) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}



private translateStatusToSpanish(status: string): string {
  const translations: Record<string, string> = {
    'succeeded': 'Exitoso',
    'SUCCESS': 'Exitoso',
    'processing': 'Cancelado',
    'error': 'Rechazado',
    'ERROR': 'Rechazado'
  };

  return translations[status] || status;
}

  // @HostListener('window:beforeunload', ['$event'])
  // unloadHandler(event: Event) {
  //   // Limpiar el valor del localStorage al cerrar la pestaña
  //   localStorage.removeItem(`channel_${this.id}`);
  // }

}
